import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: 'play',
    loadChildren: 'app/play/play.module#PlayModule',
  },
  {
    path: '',
    loadChildren: 'app/rec/rec.module#RecModule',
  },
  {
    path: 'how-to-record',
    loadChildren: 'app/how-to/how-to.module#HowToModule',
  },
  {
    path: 'about-recorder',
    loadChildren: 'app/about/about.module#AboutModule',
  },
  {
    path: 'disclaimer',
    loadChildren: 'app/disclaimer/disclaimer.module#DisclaimerModule',
  },
  {
    path: 'feedback',
    loadChildren: 'app/feedback/feedback.module#FeedbackModule',
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts